
import { 
  Home, 
  LayoutDashboard, 
  ListChecks, 
  User, 
  Code, 
  Package2, 
  UserRound, 
  Users, 
  Settings, 
  FileStack, 
  CreditCard, 
  Percent, 
  ServerCog, 
  UserCog, 
  FileCode,
  Shield
} from "lucide-react";

// User menu items
export const menuItems = [
  {
    title: "Home",
    icon: Home,
    path: "/",
    requiresSubscription: false,
    productId: undefined
  },
  {
    title: "Dashboard",
    icon: LayoutDashboard,
    path: "/dashboard",
    requiresSubscription: false,
    productId: undefined
  },
  {
    title: "My Subscriptions",
    icon: ListChecks,
    path: "/subscriptions",
    requiresSubscription: false,
    productId: undefined
  },
  {
    title: "Profile",
    icon: User,
    path: "/profile",
    requiresSubscription: false,
    productId: undefined
  }
];

// Admin related items categorized by section
const adminDashboardItems = [
  {
    title: "Dashboard",
    icon: LayoutDashboard,
    path: "/admin/dashboard"
  },
  {
    title: "Products",
    icon: Package2, 
    path: "/management"
  },
  {
    title: "Settings",
    icon: Settings,
    path: "/settings"
  }
];

const clientManagementItems = [
  {
    title: "Schools",
    icon: UserRound,
    path: "/client"
  },
  {
    title: "Users",
    icon: Users,
    path: "/users"
  },
  {
    title: "Staff",
    icon: UserCog,
    path: "/staff"
  },
  {
    title: "Admin Users",
    icon: Shield,
    path: "/admin-users"
  }
];

const financialItems = [
  {
    title: "Plans",
    icon: FileStack,
    path: "/plans"
  },
  {
    title: "Subscriptions",
    icon: ListChecks,
    path: "/admin/subscriptions"
  },
  {
    title: "Discounts",
    icon: Percent,
    path: "/discounts"
  }
];

const apiItems = [
  {
    title: "Pricing API",
    icon: FileCode,
    path: "/pricing-api-docs"
  },
  {
    title: "Payment API",
    icon: Code,
    path: "/admin/billing-webhook"
  },
  {
    title: "School API",
    icon: FileCode,
    path: "/admin/school-api-docs"
  },
  {
    title: "Subscription Status API",
    icon: ServerCog,
    path: "/admin/subscription-status-webhook"
  }
];

// Combine all admin items into the main array
export const adminMenuItems = [
  ...adminDashboardItems,
  ...clientManagementItems,
  ...financialItems,
  ...apiItems
];

// Export categorized items for direct use in components
export const adminMenuSections = {
  adminDashboard: adminDashboardItems,
  clientManagement: clientManagementItems,
  financial: financialItems,
  api: apiItems
};
